<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/money-icon.svg" alt="Historial de etapas" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">
                            Archivos PDF de presupuestos ({{ versiones.length }})
                          </h1>                          
                    </div>
                    <div class="header-actions">
                        <button class="action-btn outline" (click)="volverAlPresupuesto()">
                            Volver al presupuesto
                        </button>                          
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{ versiones.length }} elementos | Ordenado por última modificación</span>
                </div>
                <div class="content-area mt-5">
                    <div class="prospectos-table mh-50">
                        <table>
                            <thead>
                                <tr>
                                    <th class="checkbox-column text-center">
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Nombre
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Descuento
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Total
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th>
                                        <div class="d-flex align-items-center">
                                            Creado por
                                            <img src="assets/svg/arrow-down-black.svg" width="14" class="ms-1">
                                        </div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let v of versiones; let i = index">
                                  <td class="checkbox-column">
                                    <h4>{{ i + 1 }}.</h4>
                                  </td>
                                  <td>
                                    <div class="d-flex flex-row align-items-center color-org">
                                        <u class="clickable" (click)="downloadVersionPDF(v)">{{ buildVersionFileName(v) }}</u>
                                    </div>
                                  </td>
                                  <td>{{ (v.totales?.descuento_global || 0) | number:'1.0-2' }}%</td>
                                  <td>{{ (v.totales?.precio_total || 0) | currency:'CLP':'symbol':'1.0-0' }}</td>
                                  <td>
                                    <div class="d-flex flex-row align-items-center color-org">
                                      <u>{{ v.modificado_por?.nombre || v.modificado_por?.email || '-' }}</u>
                                    </div>
                                  </td>
                                  <td class="actions-cell"></td>
                                </tr>
                              </tbody>                              
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</div>